require("../css/styles.scss");

var $ = jQuery = require("jquery"),
    _ = require("underscore"),
    d3 = require("d3")

var content = [
    {
        text:"Syria currently has <span class = 'jordan-number'>4,841,406</span> refugees",
        num:4841406
},
    {
        text:"Of those, <span class = 'jordan-number'>657,433</span> are in Jordan",
        num:657433
},
    {
        text:"That’s slightly more than the <span class = 'jordan-ref'>population of Milwaukee</span>",
        num:599164
},
    {
        text:"Only <span class = 'jordan-number'>141,184</span> of the refugees in Jordan are in camps",
        num:141184
},
    {
        text:"The Zatari camp in Jordan has <span class = 'jordan-number'>79,326</span> refugees",
        num:79326
}
]

var windowWidth = $(window).innerWidth(),
    windowHeight = $(window).innerHeight();
if (windowWidth<600){
    var box = {
        'height': windowHeight-250, 
        'width': 0.86*windowWidth,
        'sidemargin': ((1-0.86)/2)*windowWidth
    }
} else {
    var box = {
        'height': windowHeight-350, 
        'width': 0.6*windowWidth,
        'sidemargin': ((1-0.6)/2)*windowWidth
    }
}
var maxrange = d3.max(content, function(e){return e.num}),
    mainarea = box.width*box.height

content.forEach(function(e,i){
    if (e.num == maxrange){
        e.area = mainarea
        e.width = box.width
        e.height = box.height
    } else if (i!=2){
        e.area = mainarea*(e.num/maxrange)
        if (content[i-1].width<600){
            var fraction = 2/3
        } 
        else {
            var fraction = 1/3
        }
        e.width = fraction*content[i-1].width
        e.height = e.area/e.width
    } else {
        e.area = mainarea*(e.num/maxrange)
        e.width = content[i-1].width*0.95
        e.height = e.area/e.width
    }
})

var activesec = 0

svg = d3.select('.jordan-area-chart')
        .append('svg')
        .attr('class','j-a-svg')
        .style('height',box.height)
        .style('width',box.width)
        .style('margin-left', box.sidemargin)
        .style('margin-right', box.sidemargin)
        .selectAll('.j-steps')
        .data(content)
        .enter()
        .append('rect')
        .attr('class','j-steps')
        .attr('height',0)
        .attr('width',0)
        .attr('data-which',function(e,i){
            return 'j-step-'+(i+1)
        })
        


$('#j-prev').on('click',function(){
    if (activesec>=0){
        $('#j-prev').removeClass('inactive')
            $('#j-next').removeClass('inactive')
        activesec = activesec - 1
        updatecontent()
        if (activesec==0){
            $('#j-prev').addClass('inactive')
        } else {
            $('#j-prev').removeClass('inactive')
        }
    }
})

$('#j-next').on('click',function(){
    if (activesec<content.length-1){
        activesec = activesec + 1
        updatecontent()
        if (activesec==content.length-1){
            $('#j-next').addClass('inactive')
        }
    } else {
        $('#j-next').addClass('inactive')
    }
    if (activesec==0){
            $('#j-prev').addClass('inactive')
        } else {

            $('#j-prev').removeClass('inactive')
        }
})

updatecontent()

function updatecontent(){
    $('.jordan-content').html(content[activesec].text)
    $('.jordan-content').attr('id','chart-chapter-'+(activesec+1))
    var active = d3.select(".j-steps[data-which='j-step-"+(activesec+1)+"']")
    active.transition()
        .duration(750)
        .attr('height',function(e){return e.height
        })
        .attr('width',function(e){return e.width
        })

    for (var i = 0; i < content.length; i++){
        if (activesec<i){
            d3.select(".j-steps[data-which='j-step-"+(i+1)+"']")
            .transition()
            .duration(750)
            .attr('height',0)
            .attr('width',0)
        }
    }
}


/*****************
 ** WEBPACK FOOTER
 ** ./js/app.js
 ** module id = 0
 ** module chunks = 0
 **/